import type { StoreLocatorProductAttribute } from "@jti/fe-common";

import { BRAND_LABELS, type BrandLabelKey } from "./constants";
import type { ValueWithLabel } from "./types";

const isValidBrandKey = (key: string): key is BrandLabelKey => key in BRAND_LABELS;

export const createMergedStickAttribute = (
  stickAttributes: StoreLocatorProductAttribute[],
  isMultiBrandSticksEnabled: boolean
) => {
  if (stickAttributes.length === 0) {
    return [];
  }

  return [
    {
      category: "Stick" as const,
      key: "Sticks",
      values: stickAttributes.reduce<ValueWithLabel[]>((acc, { key, values }) => {
        const label = isMultiBrandSticksEnabled && isValidBrandKey(key) ? BRAND_LABELS[key] : undefined;
        return [...acc, ...values.map(({ value }) => ({ value, ...(label && { label }) }))];
      }, []),
    },
  ];
};
